module.exports = __webpack_public_path__ + "static/media/pauldron-1.e8873325.glb";